<template>
  <div class="p-4">
    <el-button icon="el-icon-close" size="small" v-if="showDeleteAll"
               @click="clearSelection()">Clear Selection</el-button>&nbsp;&nbsp;
    <el-button icon="el-icon-delete" type="danger" size="small" v-if="showDeleteAll"
               @click="deleteMultiple">Delete Selected</el-button>
    <el-pagination
      class="mt-5 mb-5 float-right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      :current-page="pagination.page"
      :page-size="pagination.perPage"
      :page-count="pagination.lastPage"
      :total="pagination.total">
    </el-pagination>
    <el-table
      ref="countryTable"
      :data="countries.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%"
      @select-all="handleAllRowSelection"
      @select="handleRowSelection">
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="name" label="Name" sortable></el-table-column>
      <el-table-column prop="iso_code" label="Iso Code" sortable></el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot-scope="scope">
          <el-button @click="viewStates(scope.row.id)" type="text" size="small">
            <i class="text-xl text-gray-500 el-icon-view mr-1"></i>
          </el-button>
          <el-button @click="deleteCountry(scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-5 mb-5 float-right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      :current-page="pagination.page"
      :page-size="pagination.perPage"
      :page-count="pagination.lastPage"
      :total="pagination.total">
    </el-pagination>
  </div>
</template>

<script>
import { flatMap } from 'lodash';

export default {
  name: 'Country',
  data() {
    return {
      search: '',
      page: 1,
      limit: 20,
      showDeleteAll: false,
    };
  },
  computed: {
    countries() {
      return flatMap(this.$store.state.SettingsModule.Location.countries);
    },
    pagination() {
      return this.$store.state.SettingsModule.Location.pagination;
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    handleRowSelection() {
      this.showDeleteAll = this.$refs.countryTable.selection.length > 0;
    },
    handleAllRowSelection() {
      this.showDeleteAll = this.$refs.countryTable.selection.length > 0;
    },
    clearSelection() {
      this.$refs.countryTable.clearSelection();
      this.showDeleteAll = false;
    },
    viewStates(country_id) {
      this.$store.dispatch('SettingsModule/Location/fetchMerchantStates', { countryId: country_id });
      this.$router.push(`/ecommerce/settings/countries/${country_id}/states`);
    },
    deleteCountry(countryId) {
      this.$confirm('This will permanently delete the country. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('SettingsModule/Location/deleteMerchantCountry', { countryId });
          this.$notify.success({
            title: 'Success',
            message: 'Action was successful.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    deleteMultiple() {
      const selected = this.$refs.countryTable.selection.map(country => country.id);
      this.$confirm('Are you sure you want to delete these country?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          selected.forEach((countryId) => {
            this.$store.dispatch('SettingsModule/Location/deleteCountry', { countryId });
          });
          this.$notify.success({
            title: 'Success',
            message: 'Country has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
        this.clearSelection();
      });
    },
    getCountries() {
      try {
        this.$store.dispatch('SettingsModule/Location/fetchMerchantCountries', { page: this.page, limit: this.limit });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
    handleSizeChange(args) {
      this.limit = args;
      this.getCountries();
    },
    handlePageChange(args) {
      this.page = args;
      this.getCountries();
    },
  },
};
</script>

<style>
</style>
